/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React from 'react';
import bottle from './assets/bottle-info.svg';
import clock from './assets/clock.svg';
import pricing from './assets/pricing.svg';
import access from './assets/access.svg';
import secure from './assets/secure.svg';
import forYou from './assets/for-you.svg';
import { useScrollReveal } from '~/hooks/useScrollReveal';
import styles from '~/components/views/Trading/TradingBenefits.module.scss';
import classNames from 'classnames';

interface ValuePropCardProps {
    header: string;
    description: string;
    svg: string;
}

const valueProps: Array<ValuePropCardProps> = [
    {
        header: '100% Authentic',
        description: 'Every wine goes through a multi-step authentication process with our expert wine authenticators.',
        svg: bottle.src as string
    },
    {
        header: 'No Minimums',
        description:
            'Say goodbye to minimum hold times and account balances. Invest in the wines you want, when you want.',
        svg: clock.src as string
    },
    {
        header: 'Transparent Pricing',
        description:
            'Our real-time trading platform works like the stock market, so you can buy and sell wine at its true market value.  ',
        svg: pricing.src as string
    },
    {
        header: 'Global Access',
        description:
            'Our global marketplace gives you access to rare, hard-to-find, and exclusive wines that you can’t find anywhere else.',
        svg: access.src as string
    },
    {
        header: 'Secure',
        description: 'Vinovest partners with industry leaders to stop fraud and security breaches before they happen.',
        svg: secure.src as string
    },
    {
        header: 'Here For You',
        description: 'Got questions? Contact our support team at hello@vinovest.co.',
        svg: forYou.src as string
    }
];

function OneProp(props: { valueProp: ValuePropCardProps }) {
    const ref = React.useRef<HTMLDivElement>(null);
    const { hasRevealed } = useScrollReveal({ ref });
    const runAnimation = hasRevealed ? styles.runAnimation : '';

    return (
        <div ref={ref} className={classNames(styles.value, runAnimation)}>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src={props.valueProp.svg} alt={`${props.valueProp.header} graphic`} aria-hidden />
            <h3 className={'heading-4'}>{props.valueProp.header}</h3>
            <span>{props.valueProp.description}</span>
        </div>
    );
}

export const TradingBenefits = () => {
    const ref = React.useRef<HTMLDivElement>(null);
    const { hasRevealed } = useScrollReveal({ ref });
    const runAnimation = hasRevealed ? styles.runAnimation : '';

    return (
        <div className={classNames(styles.container, runAnimation)}>
            {valueProps.map((valueProp) => (
                <OneProp key={valueProp.header} valueProp={valueProp} />
            ))}
        </div>
    );
};
